import { mapState } from 'vuex';
export default {
  data() {
    return {
      msg: 'notConnect'
    };
  },
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  created() {
    window.addEventListener('online', info => {
      this.State.networkConnect = true;
    });
    window.addEventListener('offline', info => {
      this.State.networkConnect = false;
    });
  },
  computed: {
    ...mapState({
      State: state => state
    })
  }
};